import React, { useState, useEffect, useRef } from 'react';
import { BiSearch, BiDotsVerticalRounded, BiChevronLeft } from 'react-icons/bi';
import { BsCameraVideo, BsTelephone, BsEmojiSmile, BsCameraVideoFill } from 'react-icons/bs';
import { IoMdSend } from 'react-icons/io';
import { FaCircle } from 'react-icons/fa';
import EmojiPicker from 'emoji-picker-react';
import { BsPaperclip } from 'react-icons/bs';
import { FiImage, FiFile, FiMapPin, FiCamera, FiUser, FiVideo } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';

function MessagesPage() {
  const { currentUser } = useAuth();
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userType = userData?.generalDetails?.userType;
  const senderID = JSON.parse(localStorage.getItem('userID'));

  // State variables
  const [activeChat, setActiveChat] = useState(null);
  const [messageInput, setMessageInput] = useState('');
  const [conversations, setConversations] = useState([]);
  const [allMessages, setAllMessages] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);

  // Refs and UI state
  const messagesEndRef = useRef(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef(null);
  const [showAttachmentMenu, setShowAttachmentMenu] = useState(false);
  const attachmentMenuRef = useRef(null);
  const [attachments, setAttachments] = useState([]);
  const fileInputRef = useRef(null);
  const [fileType, setFileType] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch users list
        const usersResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/index.php`,
          new URLSearchParams({ apiType: 'fetchUsers', currentUserType: userType }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
        setUsersList(usersResponse.data.users);

        // Fetch conversations
        const convResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/index.php`,
          new URLSearchParams({ apiType: 'fetchConversations', userID: senderID }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
        setConversations(convResponse.data.conversations);
        console.log("conversation Response = ", convResponse.data);
        if (convResponse.data.conversations.length > 0) {
          setActiveChat(convResponse.data.conversations[0]);
          fetchMessages(convResponse.data.conversations[0].conversationID);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (senderID) fetchData();
  }, [senderID, userType]);

  const fetchMessages = async (conversationID, receiverID) => {
    try {
      console.log("Conversation ID", conversationID);
      console.log("sender ID", senderID);
      const formData = new FormData();
      formData.append('apiType', 'fetchMessages');
      formData.append('conversationID', conversationID);
      formData.append('userID', senderID);
      formData.append('receiverID', receiverID);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
     /* const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        new URLSearchParams({ 
          apiType: 'fetchMessages',
          conversationID: conversationID,
          userID: senderID 
        }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      */
      setAllMessages(response.data.messages);
      console.log("Data From Backend Messages = ", response.data);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const handleStartConversation = async (user) => {
    console.log("Selected User = ", user);
    
    try {
      // Check if conversation exists
      const existingConv = conversations.find(c => c.participantID === user.userID);
      console.log("Existing Conversation ? = ", existingConv);
      if (existingConv) {
        setActiveChat(existingConv);
        fetchMessages(existingConv.conversationID, user.userID);
        console.log("ConversationID in check for conversations = ", existingConv.conversationID);
        return;
      }
     
      // Create new conversation
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        new URLSearchParams({
          apiType: 'createConversation',
          senderID: senderID,
          receiverID: user.userID
        }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      const newConversation = {
        ...response.data.conversation,
        userType: user.userType,
        name: `${user.firstName} ${user.lastName}`,
        lastMessage: '',
        timestamp: new Date().toISOString(),
        unread: 0,
        online: user.status_online_offline === 'online'
      };

      setConversations(prev => [newConversation, ...prev]);
      setActiveChat(newConversation);
      console("Conversation with lastMessage", newConversation);
    } catch (error) {
      console.error("Error starting conversation:", error);
    }
  };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map(file => ({
      type: fileType,
      file: file,
      preview: URL.createObjectURL(file),
      details: {
        original_name: file.name,
        file_size: file.size,
        file_type: file.type
      }
    }));
    setAttachments(prev => [...prev, ...newAttachments]);
  };

  const handleLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            type: 'location',
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            url: `https://www.google.com/maps?q=${position.coords.latitude},${position.coords.longitude}`
          };
          setAttachments(prev => [...prev, location]);
        },
        (error) => {
          console.error('Error getting location:', error);
          alert('Unable to retrieve your location');
        }
      );
    } else {
      alert('Geolocation is not supported by this browser');
    }
  };

  const handleCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      const videoTrack = stream.getVideoTracks()[0];
      const imageCapture = new ImageCapture(videoTrack);
      
      const blob = await imageCapture.takePhoto();
      const file = new File([blob], 'camera-capture.jpg', { type: 'image/jpeg' });
      
      setAttachments(prev => [...prev, {
        type: 'image',
        file: file,
        preview: URL.createObjectURL(file),
        details: {
          original_name: 'camera-capture.jpg',
          file_size: blob.size,
          file_type: 'image/jpeg'
        }
      }]);
      
      stream.getTracks().forEach(track => track.stop());
    } catch (error) {
      console.error('Error accessing camera:', error);
      alert('Camera access denied');
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [allMessages, activeChat]);

  const onEmojiClick = (emojiObject) => {
    setMessageInput(prev => prev + emojiObject.emoji);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) 
      ){
        setShowEmojiPicker(false);
      }
    
      if (attachmentMenuRef.current && !attachmentMenuRef.current.contains(event.target)) {
        setShowAttachmentMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSendMessage = async () => {
    if (!activeChat || (!messageInput.trim() && attachments.length === 0)) return;
//console.log("Active Chat Data", activeChat); //participantID
    try {
      const formData = new FormData();
      formData.append("text", messageInput);
      formData.append("senderID", senderID);
      formData.append("receiverID", activeChat.participantID);
      formData.append("conversationID", activeChat.conversationID);
      formData.append("apiType", "createMessage");
      attachments.forEach((attachment, index) => {
        if (attachment.file) {
          formData.append(`attachments[${index}]`, attachment.file);
        }
        if (attachment.type === 'location') {
          formData.append(`locations[${index}]`, JSON.stringify(attachment));
        }
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/index.php`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      console.log("data am receiving from Backend =", response.data);
      setMessageInput('');
      setAttachments([]);
      setShowEmojiPicker(false);
      fetchMessages(activeChat.conversationID, activeChat.participantID);
      
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const renderAttachmentPreview = (attachment, index) => {
    switch (attachment.type) {
      case 'image':
        return (
          <img 
            src={attachment.preview || attachment.file_path} 
            alt="Preview" 
            className="rounded"
            style={{ width: 50, height: 50, objectFit: 'cover' }}
          />
        );
      case 'video':
        return (
          <div className="bg-light p-1 rounded position-relative">
            <FiVideo size={24} className="text-primary" />
            <small className="d-block text-truncate" style={{ maxWidth: 80 }}>
              {attachment.details?.original_name}
            </small>
          </div>
        );
      case 'document':
        return (
          <div className="bg-light p-1 rounded">
            <FiFile size={24} className="text-primary" />
            <small className="d-block text-truncate" style={{ maxWidth: 80 }}>
              {attachment.details?.original_name}
            </small>
          </div>
        );
      case 'location':
        return (
          <div className="bg-danger text-white p-2 rounded">
            <FiMapPin size={20} />
            <small className="d-block">Location</small>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container-fluid h-100 mt-5">
      <div className="row h-100">
        {/* Users List Column */}
        <div className="col-md-3 border-end p-0 bg-light">
          <div className="d-flex flex-column h-100">
            <div className="p-3 border-bottom bg-white">
              <h5 className="mb-0">Users</h5>
            </div>
            <div className="flex-grow-1 overflow-auto">
              {usersList.map(user => (
                <div
                  key={user.userID}
                  onClick={() => handleStartConversation(user)}
                  className="p-3 border-bottom chat-item"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className={`rounded-circle ${user.userType === 'staff' ? 'bg-info' : 'bg-success'}`}
                         style={{ width: 40, height: 40 }}>
                      <FiUser className="text-white m-1" size={20} />
                    </div>
                    <div className="ms-3">
                      <h6 className="mb-0">
                        {user.firstName} {user.lastName}
                        <small className={`ms-2 badge ${user.userType === 'staff' ? 'bg-info' : 'bg-success'}`}>
                          {user.userType}
                        </small>
                      </h6>
                      <small className={`text-${user.status_online_offline === 'online' ? 'success' : 'muted'}`}>
                        {user.status_online_offline}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Conversations List Column */}
        <div className="col-md-3 border-end p-0 bg-light">
          <div className="d-flex flex-column h-100">
            <div className="p-3 border-bottom bg-white">
              <h5 className="mb-0">Conversations</h5>
            </div>
            <div className="flex-grow-1 overflow-auto">
              {conversations.map(conv => (
                <div
                  key={conv.conversationID}
                  onClick={() => {
                    setActiveChat(conv);
                    fetchMessages(conv.conversationID);
                  }}
                  className={`p-3 border-bottom chat-item ${activeChat?.conversationID === conv.conversationID ? 'bg-white' : ''}`}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="position-relative">
                      <div className={`rounded-circle ${conv.userType === 'staff' ? 'bg-info' : 'bg-success'}`}
                           style={{ width: 40, height: 40 }}>
                        <FiUser className="text-white m-1" size={20} />
                      </div>
                      {conv.online && (
                        <FaCircle className="text-success position-absolute"
                          style={{ bottom: 0, right: 0, fontSize: '0.75rem' }} />
                      )}
                    </div>
                    <div className="ms-3 flex-grow-1">
                      <div className="d-flex justify-content-between">
                        <h6 className="mb-0">
                          {conv.name}
                          <small className={`ms-2 badge ${conv.userType === 'staff' ? 'bg-info' : 'bg-success'}`}>
                            {conv.userType}
                          </small>
                        </h6>
                        <small className="text-muted">
                          {conv.timestamp}
                        </small>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0 text-muted text-truncate" style={{ maxWidth: '200px' }}>
                          {conv.lastMessage}
                        </p>
                        {conv.unread > 0 && (
                          <span className="badge bg-primary rounded-pill">{conv.unread}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Chat Area Column */}
        <div className="col-md-6 p-0 d-flex flex-column" style={{ height: '90vh' }}>
          {activeChat ? (
            <>
              <div className="p-3 border-bottom bg-white d-flex align-items-center">
                <div className="d-flex align-items-center flex-grow-1">
                  <div className="position-relative me-3">
                    <div className={`rounded-circle ${activeChat.userType === 'staff' ? 'bg-info' : 'bg-success'}`}
                         style={{ width: 40, height: 40 }}>
                      <FiUser className="text-white m-1" size={20} />
                    </div>
                    {activeChat.online && (
                      <FaCircle className="text-success position-absolute"
                        style={{ bottom: 0, right: 0, fontSize: '0.75rem' }} />
                    )}
                  </div>
                  <div>
                    <h6 className="mb-0">
                      {activeChat.name}
                      <small className={`ms-2 badge ${activeChat.userType === 'staff' ? 'bg-info' : 'bg-success'}`}>
                        {activeChat.userType}
                      </small>
                    </h6>
                    <small className="text-muted">
                      {activeChat.online ? 'Online' : 'Offline'}
                    </small>
                  </div>
                </div>
                <div className="d-flex gap-3">
                  <BsTelephone className="text-muted" size={20} />
                  <BsCameraVideo className="text-muted" size={20} />
                  <BiDotsVerticalRounded className="text-muted" size={20} />
                </div>
              </div>

              <div className="flex-grow-1 overflow-auto p-3 bg-chat">
                {allMessages.map((message, index) => (
                  <div
                    key={index}
                    className={`d-flex mb-3 ${message.senderID === senderID ? 'justify-content-end' : 'justify-content-start'}`}
                  >
                    <div
                      className={`p-3 rounded-4 ${message.senderID === senderID ? 'bg-primary text-white' : 'bg-white'}`}
                      style={{ maxWidth: '70%' }}
                    >
                      {message.text && <p className="mb-2">{message.text}</p>}
                      
                      {message.attachments?.length > 0 && (
                        <div className="d-flex gap-2 flex-wrap mb-2">
                          {message.attachments.map((attachment, idx) => (
                            <div key={idx} className="position-relative">
                              {renderAttachmentPreview(attachment, idx)}
                              {message.senderID === senderID && (
                                <span className={`badge ${message.status === 'read' ? 'bg-success' : 'bg-secondary'} position-absolute top-0 start-0`}>
                                  {message.status}
                                </span>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      <small className={`d-block text-end ${message.senderID === senderID ? 'text-white-50' : 'text-muted'}`}>
                        {new Date(message.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </small>
                    </div>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>

              <div className="p-3 border-top bg-white position-relative">
                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center gap-2">
                    <div className="position-relative">
                      <BsPaperclip
                        className="text-muted cursor-pointer"
                        size={24}
                        onClick={() => {
                          setShowAttachmentMenu(!showAttachmentMenu);
                          setShowEmojiPicker(false);
                        }}
                      />
                      
                      {showAttachmentMenu && (
                        <div 
                          ref={attachmentMenuRef}
                          className="position-absolute bg-white rounded-3 shadow-sm p-2"
                          style={{ bottom: '100%', left: 0, zIndex: 1001, marginBottom: '10px', width: '200px' }}
                        >
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileUpload}
                            multiple
                          />
                          <div className="d-flex flex-column gap-2">
                            <button className="btn btn-light text-start d-flex align-items-center gap-2"
                              onClick={() => { setFileType('image'); fileInputRef.current?.click(); }}>
                              <FiImage size={18} className="text-primary mr-2" /> Pictures
                            </button>
                            <button className="btn btn-light text-start d-flex align-items-center gap-2"
                              onClick={() => { setFileType('document'); fileInputRef.current?.click(); }}>
                              <FiFile size={18} className="text-info mr-2" /> Documents
                            </button>
                            <button className="btn btn-light text-start d-flex align-items-center gap-2"
                              onClick={handleLocation}>
                              <FiMapPin size={18} className="text-danger mr-2" /> Location
                            </button>
                            <button className="btn btn-light text-start d-flex align-items-center gap-2"
                              onClick={handleCamera}>
                              <FiCamera size={18} className="text-warning mr-2" /> Camera
                            </button>
                            <button className="btn btn-light text-start d-flex align-items-center gap-2"
                              onClick={() => { setFileType('video'); fileInputRef.current?.click(); }}>
                              <BsCameraVideoFill size={18} className="text-success mr-2" /> Video
                            </button>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="position-relative">
                      <BsEmojiSmile 
                        className="text-muted cursor-pointer"
                        size={24}
                        onClick={() => {
                          setShowEmojiPicker(!showEmojiPicker);
                          setShowAttachmentMenu(false);
                        }}
                      />
                      
                      {showEmojiPicker && (
                        <div ref={emojiPickerRef} className="position-absolute"
                          style={{ bottom: '100%', left: 0, zIndex: 1000, marginBottom: '10px' }}>
                          <EmojiPicker
                            onEmojiClick={onEmojiClick}
                            previewConfig={{ showPreview: false }}
                            skinTonesDisabled
                            searchDisabled={false}
                            height={350}
                            width={300}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <input
                    type="text"
                    className="form-control rounded-pill border-0 bg-light"
                    placeholder="Type a message"
                    value={messageInput}
                    onChange={(e) => setMessageInput(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />

                  <button
                    className="btn btn-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
                    onClick={handleSendMessage}
                    style={{ width: 40, height: 40 }}
                  >
                    <IoMdSend size={20} />
                  </button>
                </div>

                {attachments.length > 0 && (
                  <div className="mt-2 d-flex gap-2 flex-wrap">
                    {attachments.map((attachment, index) => (
                      <div key={index} className="position-relative">
                        {renderAttachmentPreview(attachment, index)}
                        <button 
                          onClick={() => setAttachments(prev => prev.filter((_, i) => i !== index))}
                          className="btn btn-danger btn-sm position-absolute top-0 end-0"
                          style={{ transform: 'translate(30%, -30%)' }}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center h-100 bg-light">
              <div className="text-center">
                <h4 className="text-muted">Select a chat to start messaging</h4>
                <p className="text-muted">Your previous conversations will appear here</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .bg-chat {
          background-image: url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.1'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }
        .chat-item:hover {
          background-color: rgba(0,0,0,0.05);
        }
        .rounded-4 {
          border-radius: 1rem !important;
        }
      `}</style>
    </div>
  );
}

export default MessagesPage;